[
 {
   "_id": 157,
   "school_code": 17501,
   "nom": "Laurentienne",
   "ville": "Val-Morin",
   "secteur": "privé",
   "rang_2021_2022": 93,
   "rang_moyenne_5_ans": "107",
   "tendance": "—",
   "cote_2021_2022": 7.4,
   "cote_moyenne_5_ans": "7.0",
   "ehdaa": 34.5
 },
 {
   "_id": 175,
   "school_code": 65501,
   "nom": "Charles-Lemoyne-Sainte-Catherine",
   "ville": "Sainte-Catherine",
   "secteur": "privé",
   "rang_2021_2022": 74,
   "rang_moyenne_5_ans": "88",
   "tendance": "—",
   "cote_2021_2022": 7.7,
   "cote_moyenne_5_ans": "7.4",
   "ehdaa": 33.7
 },
 {
   "_id": 62,
   "school_code": 65505,
   "nom": "Charles-Lemoyne-Longueuil",
   "ville": "Longueuil",
   "secteur": "privé",
   "rang_2021_2022": 53,
   "rang_moyenne_5_ans": "61",
   "tendance": "—",
   "cote_2021_2022": 8.2,
   "cote_moyenne_5_ans": "8.0",
   "ehdaa": 41.9
 },
 {
   "_id": 183,
   "school_code": 66501,
   "nom": "Clarétain",
   "ville": "Victoriaville",
   "secteur": "privé",
   "rang_2021_2022": 132,
   "rang_moyenne_5_ans": "107",
   "tendance": "—",
   "cote_2021_2022": 6.9,
   "cote_moyenne_5_ans": "7.0",
   "ehdaa": 33.1
 },
 {
   "_id": 54,
   "school_code": 69501,
   "nom": "de Champigny",
   "ville": "Québec",
   "secteur": "privé",
   "rang_2021_2022": 80,
   "rang_moyenne_5_ans": "103",
   "tendance": "—",
   "cote_2021_2022": 7.6,
   "cote_moyenne_5_ans": "7.1",
   "ehdaa": 42.6
 },
 {
   "_id": 215,
   "school_code": 85501,
   "nom": "Collège Dina Bélanger",
   "ville": "Saint-Michel-de-Bellechasse",
   "secteur": "privé",
   "rang_2021_2022": 179,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 6.4,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 31
 },
 {
   "_id": 118,
   "school_code": 86501,
   "nom": "Mont-Sainte-Anne",
   "ville": "Sherbrooke",
   "secteur": "privé",
   "rang_2021_2022": 411,
   "rang_moyenne_5_ans": "314",
   "tendance": "—",
   "cote_2021_2022": 3.9,
   "cote_moyenne_5_ans": "5.0",
   "ehdaa": 36.7
 },
 {
   "_id": 233,
   "school_code": 123501,
   "nom": "Mont-Sacré-Coeur",
   "ville": "Granby",
   "secteur": "privé",
   "rang_2021_2022": 121,
   "rang_moyenne_5_ans": "88",
   "tendance": "—",
   "cote_2021_2022": 7,
   "cote_moyenne_5_ans": "7.4",
   "ehdaa": 30
 },
 {
   "_id": 155,
   "school_code": 127501,
   "nom": "Notre-Dame-de-l'Assomption",
   "ville": "Nicolet",
   "secteur": "privé",
   "rang_2021_2022": 234,
   "rang_moyenne_5_ans": "219",
   "tendance": "—",
   "cote_2021_2022": 6,
   "cote_moyenne_5_ans": "5.8",
   "ehdaa": 34.6
 },
 {
   "_id": 186,
   "school_code": 147501,
   "nom": "Saint-Bernard",
   "ville": "Drummondville",
   "secteur": "privé",
   "rang_2021_2022": 179,
   "rang_moyenne_5_ans": "173",
   "tendance": "—",
   "cote_2021_2022": 6.4,
   "cote_moyenne_5_ans": "6.2",
   "ehdaa": 32.9
 },
 {
   "_id": 80,
   "school_code": 159501,
   "nom": "Saint-Paul",
   "ville": "Varennes",
   "secteur": "privé",
   "rang_2021_2022": 38,
   "rang_moyenne_5_ans": "61",
   "tendance": "112233",
   "cote_2021_2022": 8.5,
   "cote_moyenne_5_ans": "8.0",
   "ehdaa": 39.7
 },
 {
   "_id": 204,
   "school_code": 166501,
   "nom": "Ville-Marie",
   "ville": "Montréal",
   "secteur": "privé",
   "rang_2021_2022": 203,
   "rang_moyenne_5_ans": "208",
   "tendance": "—",
   "cote_2021_2022": 6.2,
   "cote_moyenne_5_ans": "5.9",
   "ehdaa": 31.8
 },
 {
   "_id": 179,
   "school_code": 229501,
   "nom": "Maïmonide (Jacob Safra)",
   "ville": "Montréal",
   "secteur": "privé",
   "rang_2021_2022": 107,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 7.2,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 33.3
 },
 {
   "_id": 5,
   "school_code": 304501,
   "nom": "Les Trois Saisons",
   "ville": "Boucherville",
   "secteur": "privé",
   "rang_2021_2022": 158,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 6.6,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 74
 },
 {
   "_id": 25,
   "school_code": 314501,
   "nom": "Bromptonville",
   "ville": "Sherbrooke",
   "secteur": "privé",
   "rang_2021_2022": 203,
   "rang_moyenne_5_ans": "146",
   "tendance": "—",
   "cote_2021_2022": 6.2,
   "cote_moyenne_5_ans": "6.5",
   "ehdaa": 48.9
 },
 {
   "_id": 214,
   "school_code": 315501,
   "nom": "du Verbe Divin",
   "ville": "Granby",
   "secteur": "privé",
   "rang_2021_2022": 99,
   "rang_moyenne_5_ans": "88",
   "tendance": "—",
   "cote_2021_2022": 7.3,
   "cote_moyenne_5_ans": "7.4",
   "ehdaa": 31
 },
 {
   "_id": 32,
   "school_code": 321501,
   "nom": "Jeanne-Normandin",
   "ville": "Montréal",
   "secteur": "privé",
   "rang_2021_2022": 121,
   "rang_moyenne_5_ans": "326",
   "tendance": "112233",
   "cote_2021_2022": 7,
   "cote_moyenne_5_ans": "4.9",
   "ehdaa": 45.9
 },
 {
   "_id": 65,
   "school_code": 336501,
   "nom": "Saint-Joseph",
   "ville": "Saint-Hyacinthe",
   "secteur": "privé",
   "rang_2021_2022": 61,
   "rang_moyenne_5_ans": "61",
   "tendance": "—",
   "cote_2021_2022": 8,
   "cote_moyenne_5_ans": "8.0",
   "ehdaa": 41.4
 },
 {
   "_id": 131,
   "school_code": 388501,
   "nom": "Sacred Heart",
   "ville": "Montréal",
   "secteur": "privé",
   "rang_2021_2022": 93,
   "rang_moyenne_5_ans": "61",
   "tendance": "—",
   "cote_2021_2022": 7.4,
   "cote_moyenne_5_ans": "8.0",
   "ehdaa": 35.9
 },
 {
   "_id": 91,
   "school_code": 404503,
   "nom": "Bialik",
   "ville": "Côte-Saint-Luc",
   "secteur": "privé",
   "rang_2021_2022": 67,
   "rang_moyenne_5_ans": "50",
   "tendance": "—",
   "cote_2021_2022": 7.8,
   "cote_moyenne_5_ans": "8.2",
   "ehdaa": 38.8
 },
 {
   "_id": 207,
   "school_code": 445501,
   "nom": "Collège Trinité",
   "ville": "Saint-Bruno-de-Montarville",
   "secteur": "privé",
   "rang_2021_2022": 53,
   "rang_moyenne_5_ans": "61",
   "tendance": "—",
   "cote_2021_2022": 8.2,
   "cote_moyenne_5_ans": "8.0",
   "ehdaa": 31.7
 },
 {
   "_id": 3,
   "school_code": 449501,
   "nom": "des Hauts Sommets",
   "ville": "Saint-Tite-des-Caps",
   "secteur": "privé",
   "rang_2021_2022": 455,
   "rang_moyenne_5_ans": "410",
   "tendance": "—",
   "cote_2021_2022": 2.4,
   "cote_moyenne_5_ans": "1.5",
   "ehdaa": 88
 },
 {
   "_id": 221,
   "school_code": 464501,
   "nom": "Herzliah High School",
   "ville": "Montréal",
   "secteur": "privé",
   "rang_2021_2022": 67,
   "rang_moyenne_5_ans": "55",
   "tendance": "—",
   "cote_2021_2022": 7.8,
   "cote_moyenne_5_ans": "8.1",
   "ehdaa": 30.5
 },
 {
   "_id": 57,
   "school_code": 515501,
   "nom": "l'Eau-Vive",
   "ville": "Québec",
   "secteur": "privé",
   "rang_2021_2022": 347,
   "rang_moyenne_5_ans": "219",
   "tendance": "—",
   "cote_2021_2022": 4.9,
   "cote_moyenne_5_ans": "5.8",
   "ehdaa": 42.4
 },
 {
   "_id": 126,
   "school_code": 524501,
   "nom": "Nouvelles Frontières",
   "ville": "Gatineau",
   "secteur": "privé",
   "rang_2021_2022": 48,
   "rang_moyenne_5_ans": "30",
   "tendance": "—",
   "cote_2021_2022": 8.3,
   "cote_moyenne_5_ans": "8.6",
   "ehdaa": 36.2
 },
 {
   "_id": 110,
   "school_code": 711021,
   "nom": "Armand-Saint-Onge",
   "ville": "Amqui",
   "secteur": "public",
   "rang_2021_2022": 286,
   "rang_moyenne_5_ans": "277",
   "tendance": "112233",
   "cote_2021_2022": 5.5,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 37.3
 },
 {
   "_id": 152,
   "school_code": 712003,
   "nom": "Paul-Hubert",
   "ville": "Rimouski",
   "secteur": "public",
   "rang_2021_2022": 217,
   "rang_moyenne_5_ans": "253",
   "tendance": "—",
   "cote_2021_2022": 6.1,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 34.7
 },
 {
   "_id": 74,
   "school_code": 712005,
   "nom": "du le Mistral",
   "ville": "Mont-Joli",
   "secteur": "public",
   "rang_2021_2022": 399,
   "rang_moyenne_5_ans": "368",
   "tendance": "—",
   "cote_2021_2022": 4.1,
   "cote_moyenne_5_ans": "4.2",
   "ehdaa": 40.2
 },
 {
   "_id": 145,
   "school_code": 713020,
   "nom": "Dégelis",
   "ville": "Dégelis",
   "secteur": "public",
   "rang_2021_2022": 424,
   "rang_moyenne_5_ans": "253",
   "tendance": "—",
   "cote_2021_2022": 3.6,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 35.1
 },
 {
   "_id": 82,
   "school_code": 713121,
   "nom": "Cabano",
   "ville": "Témiscouata-sur-le-Lac",
   "secteur": "public",
   "rang_2021_2022": 424,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2021_2022": 3.6,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 39.7
 },
 {
   "_id": 71,
   "school_code": 713132,
   "nom": "du Transcontinental",
   "ville": "Pohénégamook",
   "secteur": "public",
   "rang_2021_2022": 337,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 5,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 40.8
 },
 {
   "_id": 229,
   "school_code": 714021,
   "nom": "Rivière-du-Loup",
   "ville": "Rivière-du-Loup",
   "secteur": "public",
   "rang_2021_2022": 192,
   "rang_moyenne_5_ans": "208",
   "tendance": "—",
   "cote_2021_2022": 6.3,
   "cote_moyenne_5_ans": "5.9",
   "ehdaa": 30.2
 },
 {
   "_id": 49,
   "school_code": 714022,
   "nom": "Chanoine-Beaudet",
   "ville": "Saint-Pascal",
   "secteur": "public",
   "rang_2021_2022": 121,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2021_2022": 7,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 43
 },
 {
   "_id": 58,
   "school_code": 714023,
   "nom": "La Pocatière",
   "ville": "La Pocatière",
   "secteur": "public",
   "rang_2021_2022": 164,
   "rang_moyenne_5_ans": "264",
   "tendance": "—",
   "cote_2021_2022": 6.5,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 42.4
 },
 {
   "_id": 67,
   "school_code": 721016,
   "nom": "Cité étudiante",
   "ville": "Roberval",
   "secteur": "public",
   "rang_2021_2022": 404,
   "rang_moyenne_5_ans": "370",
   "tendance": "—",
   "cote_2021_2022": 4,
   "cote_moyenne_5_ans": "4.1",
   "ehdaa": 41
 },
 {
   "_id": 150,
   "school_code": 721039,
   "nom": "des Quatre-Vents",
   "ville": "Saint-Félicien",
   "secteur": "public",
   "rang_2021_2022": 217,
   "rang_moyenne_5_ans": "228",
   "tendance": "—",
   "cote_2021_2022": 6.1,
   "cote_moyenne_5_ans": "5.7",
   "ehdaa": 34.8
 },
 {
   "_id": 137,
   "school_code": 721085,
   "nom": "Jean-Dolbeau",
   "ville": "Dolbeau-Mistassini",
   "secteur": "public",
   "rang_2021_2022": 352,
   "rang_moyenne_5_ans": "314",
   "tendance": "—",
   "cote_2021_2022": 4.8,
   "cote_moyenne_5_ans": "5.0",
   "ehdaa": 35.5
 },
 {
   "_id": 228,
   "school_code": 722002,
   "nom": "Camille-Lavoie",
   "ville": "Alma",
   "secteur": "public",
   "rang_2021_2022": 150,
   "rang_moyenne_5_ans": "107",
   "tendance": "—",
   "cote_2021_2022": 6.7,
   "cote_moyenne_5_ans": "7.0",
   "ehdaa": 30.2
 },
 {
   "_id": 47,
   "school_code": 722003,
   "nom": "Wilbrod-Dufour",
   "ville": "Alma",
   "secteur": "public",
   "rang_2021_2022": 383,
   "rang_moyenne_5_ans": "382",
   "tendance": "—",
   "cote_2021_2022": 4.4,
   "cote_moyenne_5_ans": "3.9",
   "ehdaa": 43.7
 },
 {
   "_id": 188,
   "school_code": 722009,
   "nom": "Jean-Gauthier",
   "ville": "Alma",
   "secteur": "public",
   "rang_2021_2022": 352,
   "rang_moyenne_5_ans": "382",
   "tendance": "—",
   "cote_2021_2022": 4.8,
   "cote_moyenne_5_ans": "3.9",
   "ehdaa": 32.9
 },
 {
   "_id": 112,
   "school_code": 723145,
   "nom": "Charles-Gravel",
   "ville": "Saguenay",
   "secteur": "public",
   "rang_2021_2022": 337,
   "rang_moyenne_5_ans": "326",
   "tendance": "—",
   "cote_2021_2022": 5,
   "cote_moyenne_5_ans": "4.9",
   "ehdaa": 37.3
 },
 {
   "_id": 158,
   "school_code": 723173,
   "nom": "des Grandes-Marées",
   "ville": "Saguenay",
   "secteur": "public",
   "rang_2021_2022": 393,
   "rang_moyenne_5_ans": "346",
   "tendance": "—",
   "cote_2021_2022": 4.2,
   "cote_moyenne_5_ans": "4.6",
   "ehdaa": 34.5
 },
 {
   "_id": 114,
   "school_code": 724014,
   "nom": "Jonquière",
   "ville": "Saguenay",
   "secteur": "public",
   "rang_2021_2022": 439,
   "rang_moyenne_5_ans": "388",
   "tendance": "—",
   "cote_2021_2022": 3.3,
   "cote_moyenne_5_ans": "3.7",
   "ehdaa": 37.3
 },
 {
   "_id": 220,
   "school_code": 731001,
   "nom": "Saint-Aubin",
   "ville": "Baie-Saint-Paul",
   "secteur": "public",
   "rang_2021_2022": 132,
   "rang_moyenne_5_ans": "125",
   "tendance": "—",
   "cote_2021_2022": 6.9,
   "cote_moyenne_5_ans": "6.8",
   "ehdaa": 30.6
 },
 {
   "_id": 218,
   "school_code": 731002,
   "nom": "du Plateau",
   "ville": "La Malbaie",
   "secteur": "public",
   "rang_2021_2022": 286,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 5.5,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 30.7
 },
 {
   "_id": 98,
   "school_code": 732161,
   "nom": "La Camaradière",
   "ville": "Québec",
   "secteur": "public",
   "rang_2021_2022": 327,
   "rang_moyenne_5_ans": "340",
   "tendance": "112233",
   "cote_2021_2022": 5.1,
   "cote_moyenne_5_ans": "4.7",
   "ehdaa": 38.5
 },
 {
   "_id": 135,
   "school_code": 732164,
   "nom": "de Neufchâtel",
   "ville": "Québec",
   "secteur": "public",
   "rang_2021_2022": 246,
   "rang_moyenne_5_ans": "253",
   "tendance": "—",
   "cote_2021_2022": 5.9,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 35.6
 },
 {
   "_id": 161,
   "school_code": 732165,
   "nom": "Roger-Comtois",
   "ville": "Québec",
   "secteur": "public",
   "rang_2021_2022": 316,
   "rang_moyenne_5_ans": "358",
   "tendance": "—",
   "cote_2021_2022": 5.2,
   "cote_moyenne_5_ans": "4.4",
   "ehdaa": 34.4
 },
 {
   "_id": 56,
   "school_code": 732167,
   "nom": "Vanier",
   "ville": "Québec",
   "secteur": "public",
   "rang_2021_2022": 454,
   "rang_moyenne_5_ans": "402",
   "tendance": "—",
   "cote_2021_2022": 2.5,
   "cote_moyenne_5_ans": "3.0",
   "ehdaa": 42.5
 },
 {
   "_id": 223,
   "school_code": 733002,
   "nom": "des Pionniers",
   "ville": "Saint-Augustin-de-Desmaures",
   "secteur": "public",
   "rang_2021_2022": 138,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 6.8,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 30.5
 },
 {
   "_id": 217,
   "school_code": 733030,
   "nom": "de L'Ancienne-Lorette",
   "ville": "L'Ancienne-Lorette",
   "secteur": "public",
   "rang_2021_2022": 192,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2021_2022": 6.3,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 30.8
 },
 {
   "_id": 222,
   "school_code": 733032,
   "nom": "les Compagnons-de-Cartier",
   "ville": "Québec",
   "secteur": "public",
   "rang_2021_2022": 89,
   "rang_moyenne_5_ans": "146",
   "tendance": "—",
   "cote_2021_2022": 7.5,
   "cote_moyenne_5_ans": "6.5",
   "ehdaa": 30.5
 },
 {
   "_id": 96,
   "school_code": 734051,
   "nom": "Samuel-De Champlain",
   "ville": "Québec",
   "secteur": "public",
   "rang_2021_2022": 364,
   "rang_moyenne_5_ans": "302",
   "tendance": "—",
   "cote_2021_2022": 4.7,
   "cote_moyenne_5_ans": "5.1",
   "ehdaa": 38.6
 },
 {
   "_id": 231,
   "school_code": 734065,
   "nom": "le Sommet",
   "ville": "Québec",
   "secteur": "public",
   "rang_2021_2022": 286,
   "rang_moyenne_5_ans": "302",
   "tendance": "—",
   "cote_2021_2022": 5.5,
   "cote_moyenne_5_ans": "5.1",
   "ehdaa": 30.1
 },
 {
   "_id": 132,
   "school_code": 735013,
   "nom": "Louis-Jobin",
   "ville": "Saint-Raymond",
   "secteur": "public",
   "rang_2021_2022": 389,
   "rang_moyenne_5_ans": "358",
   "tendance": "—",
   "cote_2021_2022": 4.3,
   "cote_moyenne_5_ans": "4.4",
   "ehdaa": 35.9
 },
 {
   "_id": 6,
   "school_code": 741017,
   "nom": "Avenues-Nouvelles",
   "ville": "Trois-Rivières",
   "secteur": "public",
   "rang_2021_2022": 467,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 0.7,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 70.3
 },
 {
   "_id": 75,
   "school_code": 741108,
   "nom": "L'Escale",
   "ville": "Louiseville",
   "secteur": "public",
   "rang_2021_2022": 121,
   "rang_moyenne_5_ans": "156",
   "tendance": "—",
   "cote_2021_2022": 7,
   "cote_moyenne_5_ans": "6.3",
   "ehdaa": 40
 },
 {
   "_id": 212,
   "school_code": 741109,
   "nom": "Les Estacades",
   "ville": "Trois-Rivières",
   "secteur": "public",
   "rang_2021_2022": 255,
   "rang_moyenne_5_ans": "277",
   "tendance": "112233",
   "cote_2021_2022": 5.8,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 31.3
 },
 {
   "_id": 146,
   "school_code": 741110,
   "nom": "des Pionniers",
   "ville": "Trois-Rivières",
   "secteur": "public",
   "rang_2021_2022": 264,
   "rang_moyenne_5_ans": "264",
   "tendance": "—",
   "cote_2021_2022": 5.7,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 35
 },
 {
   "_id": 106,
   "school_code": 741111,
   "nom": "Chavigny",
   "ville": "Trois-Rivières",
   "secteur": "public",
   "rang_2021_2022": 297,
   "rang_moyenne_5_ans": "358",
   "tendance": "—",
   "cote_2021_2022": 5.4,
   "cote_moyenne_5_ans": "4.4",
   "ehdaa": 38
 },
 {
   "_id": 203,
   "school_code": 741112,
   "nom": "le Tremplin",
   "ville": "Sainte-Geneviève-de-Batiscan",
   "secteur": "public",
   "rang_2021_2022": 352,
   "rang_moyenne_5_ans": "302",
   "tendance": "—",
   "cote_2021_2022": 4.8,
   "cote_moyenne_5_ans": "5.1",
   "ehdaa": 31.9
 },
 {
   "_id": 205,
   "school_code": 742097,
   "nom": "Val-Mauricie",
   "ville": "Shawinigan",
   "secteur": "public",
   "rang_2021_2022": 107,
   "rang_moyenne_5_ans": "103",
   "tendance": "—",
   "cote_2021_2022": 7.2,
   "cote_moyenne_5_ans": "7.1",
   "ehdaa": 31.8
 },
 {
   "_id": 142,
   "school_code": 742100,
   "nom": "des Chutes",
   "ville": "Shawinigan",
   "secteur": "public",
   "rang_2021_2022": 327,
   "rang_moyenne_5_ans": "228",
   "tendance": "—",
   "cote_2021_2022": 5.1,
   "cote_moyenne_5_ans": "5.7",
   "ehdaa": 35.3
 },
 {
   "_id": 208,
   "school_code": 742105,
   "nom": "Paul-Le Jeune",
   "ville": "Saint-Tite",
   "secteur": "public",
   "rang_2021_2022": 164,
   "rang_moyenne_5_ans": "253",
   "tendance": "112233",
   "cote_2021_2022": 6.5,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 31.6
 },
 {
   "_id": 121,
   "school_code": 742118,
   "nom": "Champagnat",
   "ville": "La Tuque",
   "secteur": "public",
   "rang_2021_2022": 179,
   "rang_moyenne_5_ans": "138",
   "tendance": "—",
   "cote_2021_2022": 6.4,
   "cote_moyenne_5_ans": "6.6",
   "ehdaa": 36.6
 },
 {
   "_id": 190,
   "school_code": 751006,
   "nom": "Montignac",
   "ville": "Lac-Mégantic",
   "secteur": "public",
   "rang_2021_2022": 264,
   "rang_moyenne_5_ans": "156",
   "tendance": "998855",
   "cote_2021_2022": 5.7,
   "cote_moyenne_5_ans": "6.3",
   "ehdaa": 32.6
 },
 {
   "_id": 89,
   "school_code": 751007,
   "nom": "Louis-Saint-Laurent",
   "ville": "East Angus",
   "secteur": "public",
   "rang_2021_2022": 381,
   "rang_moyenne_5_ans": "253",
   "tendance": "—",
   "cote_2021_2022": 4.5,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 39.1
 },
 {
   "_id": 9,
   "school_code": 751008,
   "nom": "La MFR",
   "ville": "Saint-Romain",
   "secteur": "public",
   "rang_2021_2022": 457,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 2.2,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 58.4
 },
 {
   "_id": 177,
   "school_code": 752117,
   "nom": "de la Montée",
   "ville": "Sherbrooke",
   "secteur": "public",
   "rang_2021_2022": 264,
   "rang_moyenne_5_ans": "253",
   "tendance": "112233",
   "cote_2021_2022": 5.7,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 33.5
 },
 {
   "_id": 104,
   "school_code": 752148,
   "nom": "du Phare",
   "ville": "Sherbrooke",
   "secteur": "public",
   "rang_2021_2022": 352,
   "rang_moyenne_5_ans": "314",
   "tendance": "—",
   "cote_2021_2022": 4.8,
   "cote_moyenne_5_ans": "5.0",
   "ehdaa": 38.2
 },
 {
   "_id": 36,
   "school_code": 753012,
   "nom": "de L'Escale",
   "ville": "Asbestos",
   "secteur": "public",
   "rang_2021_2022": 327,
   "rang_moyenne_5_ans": "340",
   "tendance": "—",
   "cote_2021_2022": 5.1,
   "cote_moyenne_5_ans": "4.7",
   "ehdaa": 45.1
 },
 {
   "_id": 159,
   "school_code": 753027,
   "nom": "de la Ruche",
   "ville": "Magog",
   "secteur": "public",
   "rang_2021_2022": 192,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2021_2022": 6.3,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 34.4
 },
 {
   "_id": 125,
   "school_code": 753053,
   "nom": "l'Odyssée",
   "ville": "Valcourt",
   "secteur": "public",
   "rang_2021_2022": 393,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 4.2,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 36.4
 },
 {
   "_id": 115,
   "school_code": 753057,
   "nom": "du Tournesol",
   "ville": "Windsor",
   "secteur": "public",
   "rang_2021_2022": 264,
   "rang_moyenne_5_ans": "288",
   "tendance": "—",
   "cote_2021_2022": 5.7,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 37.1
 },
 {
   "_id": 195,
   "school_code": 761078,
   "nom": "École sec. Anjou",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 327,
   "rang_moyenne_5_ans": "346",
   "tendance": "—",
   "cote_2021_2022": 5.1,
   "cote_moyenne_5_ans": "4.6",
   "ehdaa": 32.3
 },
 {
   "_id": 102,
   "school_code": 761090,
   "nom": "Calixa-Lavallée",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 393,
   "rang_moyenne_5_ans": "382",
   "tendance": "—",
   "cote_2021_2022": 4.2,
   "cote_moyenne_5_ans": "3.9",
   "ehdaa": 38.3
 },
 {
   "_id": 33,
   "school_code": 762248,
   "nom": "Éc. le Vitrail",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 411,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 3.9,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 45.9
 },
 {
   "_id": 209,
   "school_code": 762252,
   "nom": "Louise-Trichet",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 217,
   "rang_moyenne_5_ans": "156",
   "tendance": "—",
   "cote_2021_2022": 6.1,
   "cote_moyenne_5_ans": "6.3",
   "ehdaa": 31.5
 },
 {
   "_id": 66,
   "school_code": 762253,
   "nom": "Dunton",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 316,
   "rang_moyenne_5_ans": "336",
   "tendance": "—",
   "cote_2021_2022": 5.2,
   "cote_moyenne_5_ans": "4.8",
   "ehdaa": 41.4
 },
 {
   "_id": 149,
   "school_code": 762256,
   "nom": "Édouard-Montpetit",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 428,
   "rang_moyenne_5_ans": "370",
   "tendance": "—",
   "cote_2021_2022": 3.5,
   "cote_moyenne_5_ans": "4.1",
   "ehdaa": 34.9
 },
 {
   "_id": 8,
   "school_code": 762259,
   "nom": "Chomedey-De-Maisonneuve",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 460,
   "rang_moyenne_5_ans": "411",
   "tendance": "—",
   "cote_2021_2022": 2.1,
   "cote_moyenne_5_ans": "1.4",
   "ehdaa": 62
 },
 {
   "_id": 63,
   "school_code": 762263,
   "nom": "Louis-Joseph-Papineau",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 435,
   "rang_moyenne_5_ans": "398",
   "tendance": "—",
   "cote_2021_2022": 3.4,
   "cote_moyenne_5_ans": "3.3",
   "ehdaa": 41.7
 },
 {
   "_id": 15,
   "school_code": 762264,
   "nom": "Pierre-Dupuy",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 428,
   "rang_moyenne_5_ans": "378",
   "tendance": "—",
   "cote_2021_2022": 3.5,
   "cote_moyenne_5_ans": "4.0",
   "ehdaa": 51.5
 },
 {
   "_id": 64,
   "school_code": 762265,
   "nom": "Jeanne-Mance",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 415,
   "rang_moyenne_5_ans": "388",
   "tendance": "—",
   "cote_2021_2022": 3.8,
   "cote_moyenne_5_ans": "3.7",
   "ehdaa": 41.5
 },
 {
   "_id": 34,
   "school_code": 762269,
   "nom": "Georges-Vanier",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 428,
   "rang_moyenne_5_ans": "378",
   "tendance": "—",
   "cote_2021_2022": 3.5,
   "cote_moyenne_5_ans": "4.0",
   "ehdaa": 45.9
 },
 {
   "_id": 31,
   "school_code": 762276,
   "nom": "Marie-Anne",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 462,
   "rang_moyenne_5_ans": "407",
   "tendance": "—",
   "cote_2021_2022": 2,
   "cote_moyenne_5_ans": "2.5",
   "ehdaa": 46.4
 },
 {
   "_id": 144,
   "school_code": 762278,
   "nom": "Lucien-Pagé",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 399,
   "rang_moyenne_5_ans": "378",
   "tendance": "—",
   "cote_2021_2022": 4.1,
   "cote_moyenne_5_ans": "4.0",
   "ehdaa": 35.3
 },
 {
   "_id": 27,
   "school_code": 762286,
   "nom": "Saint-Henri",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 393,
   "rang_moyenne_5_ans": "394",
   "tendance": "112233",
   "cote_2021_2022": 4.2,
   "cote_moyenne_5_ans": "3.5",
   "ehdaa": 47.5
 },
 {
   "_id": 140,
   "school_code": 762287,
   "nom": "Honoré-Mercier",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 411,
   "rang_moyenne_5_ans": "382",
   "tendance": "—",
   "cote_2021_2022": 3.9,
   "cote_moyenne_5_ans": "3.9",
   "ehdaa": 35.4
 },
 {
   "_id": 2,
   "school_code": 763037,
   "nom": "École du Sas",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 460,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 2.1,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 88.7
 },
 {
   "_id": 192,
   "school_code": 763138,
   "nom": "Cavelier-De LaSalle",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 389,
   "rang_moyenne_5_ans": "346",
   "tendance": "—",
   "cote_2021_2022": 4.3,
   "cote_moyenne_5_ans": "4.6",
   "ehdaa": 32.6
 },
 {
   "_id": 117,
   "school_code": 763139,
   "nom": "Dalbé-Viau",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 364,
   "rang_moyenne_5_ans": "264",
   "tendance": "—",
   "cote_2021_2022": 4.7,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 37
 },
 {
   "_id": 162,
   "school_code": 763142,
   "nom": "Monseigneur-Richard",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 107,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2021_2022": 7.2,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 34.3
 },
 {
   "_id": 194,
   "school_code": 763236,
   "nom": "des Sources",
   "ville": "Dollard-Des Ormeaux",
   "secteur": "public",
   "rang_2021_2022": 246,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2021_2022": 5.9,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 32.3
 },
 {
   "_id": 108,
   "school_code": 771022,
   "nom": "Nicolas-Gatineau",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2021_2022": 255,
   "rang_moyenne_5_ans": "277",
   "tendance": "112233",
   "cote_2021_2022": 5.8,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 37.5
 },
 {
   "_id": 26,
   "school_code": 771033,
   "nom": "de L'Érablière",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2021_2022": 138,
   "rang_moyenne_5_ans": "277",
   "tendance": "112233",
   "cote_2021_2022": 6.8,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 48.6
 },
 {
   "_id": 153,
   "school_code": 771035,
   "nom": "Le Carrefour",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2021_2022": 264,
   "rang_moyenne_5_ans": "228",
   "tendance": "—",
   "cote_2021_2022": 5.7,
   "cote_moyenne_5_ans": "5.7",
   "ehdaa": 34.7
 },
 {
   "_id": 10,
   "school_code": 772042,
   "nom": "des Lacs",
   "ville": "La Pêche",
   "secteur": "public",
   "rang_2021_2022": 234,
   "rang_moyenne_5_ans": "326",
   "tendance": "—",
   "cote_2021_2022": 6,
   "cote_moyenne_5_ans": "4.9",
   "ehdaa": 57.5
 },
 {
   "_id": 50,
   "school_code": 772044,
   "nom": "Grande-Rivière",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2021_2022": 158,
   "rang_moyenne_5_ans": "241",
   "tendance": "112233",
   "cote_2021_2022": 6.6,
   "cote_moyenne_5_ans": "5.6",
   "ehdaa": 43
 },
 {
   "_id": 22,
   "school_code": 772046,
   "nom": "Mont-Bleu",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2021_2022": 234,
   "rang_moyenne_5_ans": "253",
   "tendance": "112233",
   "cote_2021_2022": 6,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 49.3
 },
 {
   "_id": 60,
   "school_code": 772048,
   "nom": "de L'Île",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2021_2022": 217,
   "rang_moyenne_5_ans": "253",
   "tendance": "—",
   "cote_2021_2022": 6.1,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 42
 },
 {
   "_id": 136,
   "school_code": 773010,
   "nom": "Louis-Joseph-Papineau",
   "ville": "Papineauville",
   "secteur": "public",
   "rang_2021_2022": 435,
   "rang_moyenne_5_ans": "314",
   "tendance": "—",
   "cote_2021_2022": 3.4,
   "cote_moyenne_5_ans": "5.0",
   "ehdaa": 35.6
 },
 {
   "_id": 48,
   "school_code": 773030,
   "nom": "Hormisdas-Gamelin",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2021_2022": 192,
   "rang_moyenne_5_ans": "241",
   "tendance": "112233",
   "cote_2021_2022": 6.3,
   "cote_moyenne_5_ans": "5.6",
   "ehdaa": 43.3
 },
 {
   "_id": 28,
   "school_code": 774001,
   "nom": "Sieur-de-Coulonge",
   "ville": "Fort-Coulonge",
   "secteur": "public",
   "rang_2021_2022": 327,
   "rang_moyenne_5_ans": "370",
   "tendance": "112233",
   "cote_2021_2022": 5.1,
   "cote_moyenne_5_ans": "4.1",
   "ehdaa": 46.8
 },
 {
   "_id": 42,
   "school_code": 774003,
   "nom": "du Coeur-de-la-Gatineau",
   "ville": "Gracefield",
   "secteur": "public",
   "rang_2021_2022": 457,
   "rang_moyenne_5_ans": "400",
   "tendance": "998855",
   "cote_2021_2022": 2.2,
   "cote_moyenne_5_ans": "3.1",
   "ehdaa": 44.4
 },
 {
   "_id": 68,
   "school_code": 774005,
   "nom": "La Cité étudiante",
   "ville": "Maniwaki",
   "secteur": "public",
   "rang_2021_2022": 316,
   "rang_moyenne_5_ans": "370",
   "tendance": "—",
   "cote_2021_2022": 5.2,
   "cote_moyenne_5_ans": "4.1",
   "ehdaa": 40.9
 },
 {
   "_id": 94,
   "school_code": 782018,
   "nom": "La Source",
   "ville": "Rouyn-Noranda",
   "secteur": "public",
   "rang_2021_2022": 164,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 6.5,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 38.6
 },
 {
   "_id": 156,
   "school_code": 782019,
   "nom": "D'Iberville",
   "ville": "Rouyn-Noranda",
   "secteur": "public",
   "rang_2021_2022": 179,
   "rang_moyenne_5_ans": "241",
   "tendance": "—",
   "cote_2021_2022": 6.4,
   "cote_moyenne_5_ans": "5.6",
   "ehdaa": 34.6
 },
 {
   "_id": 200,
   "school_code": 783023,
   "nom": "d'Amos",
   "ville": "Amos",
   "secteur": "public",
   "rang_2021_2022": 337,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 5,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 32
 },
 {
   "_id": 73,
   "school_code": 784023,
   "nom": "La Concorde",
   "ville": "Senneterre",
   "secteur": "public",
   "rang_2021_2022": 337,
   "rang_moyenne_5_ans": "364",
   "tendance": "—",
   "cote_2021_2022": 5,
   "cote_moyenne_5_ans": "4.3",
   "ehdaa": 40.5
 },
 {
   "_id": 176,
   "school_code": 784024,
   "nom": "le Tremplin",
   "ville": "Malartic",
   "secteur": "public",
   "rang_2021_2022": 264,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2021_2022": 5.7,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 33.5
 },
 {
   "_id": 199,
   "school_code": 784025,
   "nom": "Le Carrefour",
   "ville": "Val-d'Or",
   "secteur": "public",
   "rang_2021_2022": 286,
   "rang_moyenne_5_ans": "340",
   "tendance": "—",
   "cote_2021_2022": 5.5,
   "cote_moyenne_5_ans": "4.7",
   "ehdaa": 32
 },
 {
   "_id": 182,
   "school_code": 785003,
   "nom": "Polyno",
   "ville": "La Sarre",
   "secteur": "public",
   "rang_2021_2022": 297,
   "rang_moyenne_5_ans": "277",
   "tendance": "—",
   "cote_2021_2022": 5.4,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 33.2
 },
 {
   "_id": 226,
   "school_code": 791046,
   "nom": "des Rivières",
   "ville": "Forestville",
   "secteur": "public",
   "rang_2021_2022": 316,
   "rang_moyenne_5_ans": "125",
   "tendance": "—",
   "cote_2021_2022": 5.2,
   "cote_moyenne_5_ans": "6.8",
   "ehdaa": 30.4
 },
 {
   "_id": 193,
   "school_code": 791058,
   "nom": "des Baies",
   "ville": "Baie-Comeau",
   "secteur": "public",
   "rang_2021_2022": 404,
   "rang_moyenne_5_ans": "314",
   "tendance": "998855",
   "cote_2021_2022": 4,
   "cote_moyenne_5_ans": "5.0",
   "ehdaa": 32.4
 },
 {
   "_id": 123,
   "school_code": 792003,
   "nom": "Horizon-Blanc",
   "ville": "Fermont",
   "secteur": "public",
   "rang_2021_2022": 80,
   "rang_moyenne_5_ans": "219",
   "tendance": "—",
   "cote_2021_2022": 7.6,
   "cote_moyenne_5_ans": "5.8",
   "ehdaa": 36.5
 },
 {
   "_id": 97,
   "school_code": 792049,
   "nom": "L'Abri",
   "ville": "Port-Cartier",
   "secteur": "public",
   "rang_2021_2022": 375,
   "rang_moyenne_5_ans": "326",
   "tendance": "—",
   "cote_2021_2022": 4.6,
   "cote_moyenne_5_ans": "4.9",
   "ehdaa": 38.6
 },
 {
   "_id": 18,
   "school_code": 793001,
   "nom": "Monseigneur-Labrie",
   "ville": "Havre-Saint-Pierre",
   "secteur": "public",
   "rang_2021_2022": 217,
   "rang_moyenne_5_ans": "340",
   "tendance": "112233",
   "cote_2021_2022": 6.1,
   "cote_moyenne_5_ans": "4.7",
   "ehdaa": 50.7
 },
 {
   "_id": 198,
   "school_code": 801003,
   "nom": "La Porte-du-Nord",
   "ville": "Chibougamau",
   "secteur": "public",
   "rang_2021_2022": 217,
   "rang_moyenne_5_ans": "115",
   "tendance": "—",
   "cote_2021_2022": 6.1,
   "cote_moyenne_5_ans": "6.9",
   "ehdaa": 32
 },
 {
   "_id": 187,
   "school_code": 801014,
   "nom": "Le Delta",
   "ville": "Matagami",
   "secteur": "public",
   "rang_2021_2022": 192,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 6.3,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 32.9
 },
 {
   "_id": 163,
   "school_code": 801016,
   "nom": "La Taïga",
   "ville": "Lebel-sur-Quévillon",
   "secteur": "public",
   "rang_2021_2022": 393,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 4.2,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 34.3
 },
 {
   "_id": 169,
   "school_code": 811002,
   "nom": "des Îles",
   "ville": "Les Îles-de-la-Madeleine",
   "secteur": "public",
   "rang_2021_2022": 132,
   "rang_moyenne_5_ans": "179",
   "tendance": "112233",
   "cote_2021_2022": 6.9,
   "cote_moyenne_5_ans": "6.1",
   "ehdaa": 34
 },
 {
   "_id": 45,
   "school_code": 812001,
   "nom": "Saint-Norbert",
   "ville": "Cap-Chat",
   "secteur": "public",
   "rang_2021_2022": 417,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 3.7,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 44
 },
 {
   "_id": 17,
   "school_code": 812006,
   "nom": "Gabriel-Le Courtois",
   "ville": "Sainte-Anne-des-Monts",
   "secteur": "public",
   "rang_2021_2022": 428,
   "rang_moyenne_5_ans": "302",
   "tendance": "—",
   "cote_2021_2022": 3.5,
   "cote_moyenne_5_ans": "5.1",
   "ehdaa": 51.3
 },
 {
   "_id": 76,
   "school_code": 812025,
   "nom": "Esdras-Minville",
   "ville": "Grande-Vallée",
   "secteur": "public",
   "rang_2021_2022": 453,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 2.6,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 40
 },
 {
   "_id": 234,
   "school_code": 812034,
   "nom": "Antoine-Roy",
   "ville": "Gaspé",
   "secteur": "public",
   "rang_2021_2022": 428,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 3.5,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 30
 },
 {
   "_id": 95,
   "school_code": 812040,
   "nom": "C.-E.-Pouliot",
   "ville": "Gaspé",
   "secteur": "public",
   "rang_2021_2022": 337,
   "rang_moyenne_5_ans": "336",
   "tendance": "—",
   "cote_2021_2022": 5,
   "cote_moyenne_5_ans": "4.8",
   "ehdaa": 38.6
 },
 {
   "_id": 191,
   "school_code": 813012,
   "nom": "Monseigneur Sévigny",
   "ville": "Chandler",
   "secteur": "public",
   "rang_2021_2022": 364,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 4.7,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 32.6
 },
 {
   "_id": 202,
   "school_code": 813022,
   "nom": "Paspébiac",
   "ville": "Paspébiac",
   "secteur": "public",
   "rang_2021_2022": 164,
   "rang_moyenne_5_ans": "103",
   "tendance": "—",
   "cote_2021_2022": 6.5,
   "cote_moyenne_5_ans": "7.1",
   "ehdaa": 31.9
 },
 {
   "_id": 180,
   "school_code": 813036,
   "nom": "Antoine-Bernard",
   "ville": "Carleton-sur-Mer",
   "secteur": "public",
   "rang_2021_2022": 150,
   "rang_moyenne_5_ans": "156",
   "tendance": "—",
   "cote_2021_2022": 6.7,
   "cote_moyenne_5_ans": "6.3",
   "ehdaa": 33.3
 },
 {
   "_id": 16,
   "school_code": 813042,
   "nom": "des Deux-Rivières",
   "ville": "Matapédia",
   "secteur": "public",
   "rang_2021_2022": 375,
   "rang_moyenne_5_ans": "264",
   "tendance": "998855",
   "cote_2021_2022": 4.6,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 51.4
 },
 {
   "_id": 232,
   "school_code": 821261,
   "nom": "Saint-Paul",
   "ville": "Saint-Paul-de-Montminy",
   "secteur": "public",
   "rang_2021_2022": 347,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 4.9,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 30.1
 },
 {
   "_id": 147,
   "school_code": 822040,
   "nom": "Disraëli",
   "ville": "Disraeli",
   "secteur": "public",
   "rang_2021_2022": 446,
   "rang_moyenne_5_ans": "405",
   "tendance": "112233",
   "cote_2021_2022": 3,
   "cote_moyenne_5_ans": "2.8",
   "ehdaa": 35
 },
 {
   "_id": 211,
   "school_code": 823045,
   "nom": "des Abénaquis",
   "ville": "Saint-Prosper",
   "secteur": "public",
   "rang_2021_2022": 381,
   "rang_moyenne_5_ans": "354",
   "tendance": "—",
   "cote_2021_2022": 4.5,
   "cote_moyenne_5_ans": "4.5",
   "ehdaa": 31.5
 },
 {
   "_id": 85,
   "school_code": 831102,
   "nom": "Curé-Antoine-Labelle",
   "ville": "Laval",
   "secteur": "public",
   "rang_2021_2022": 203,
   "rang_moyenne_5_ans": "253",
   "tendance": "—",
   "cote_2021_2022": 6.2,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 39.4
 },
 {
   "_id": 81,
   "school_code": 831105,
   "nom": "Horizon Jeunesse",
   "ville": "Laval",
   "secteur": "public",
   "rang_2021_2022": 203,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2021_2022": 6.2,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 39.7
 },
 {
   "_id": 77,
   "school_code": 831107,
   "nom": "Leblanc",
   "ville": "Laval",
   "secteur": "public",
   "rang_2021_2022": 179,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2021_2022": 6.4,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 39.9
 },
 {
   "_id": 46,
   "school_code": 831108,
   "nom": "Georges-Vanier",
   "ville": "Laval",
   "secteur": "public",
   "rang_2021_2022": 164,
   "rang_moyenne_5_ans": "326",
   "tendance": "—",
   "cote_2021_2022": 6.5,
   "cote_moyenne_5_ans": "4.9",
   "ehdaa": 43.9
 },
 {
   "_id": 130,
   "school_code": 831114,
   "nom": "Mont-de-La Salle",
   "ville": "Laval",
   "secteur": "public",
   "rang_2021_2022": 364,
   "rang_moyenne_5_ans": "346",
   "tendance": "—",
   "cote_2021_2022": 4.7,
   "cote_moyenne_5_ans": "4.6",
   "ehdaa": 36.1
 },
 {
   "_id": 30,
   "school_code": 841008,
   "nom": "du Coteau",
   "ville": "Mascouche",
   "secteur": "public",
   "rang_2021_2022": 404,
   "rang_moyenne_5_ans": "302",
   "tendance": "—",
   "cote_2021_2022": 4,
   "cote_moyenne_5_ans": "5.1",
   "ehdaa": 46.4
 },
 {
   "_id": 99,
   "school_code": 841031,
   "nom": "Paul-Arseneau",
   "ville": "L'Assomption",
   "secteur": "public",
   "rang_2021_2022": 264,
   "rang_moyenne_5_ans": "241",
   "tendance": "—",
   "cote_2021_2022": 5.7,
   "cote_moyenne_5_ans": "5.6",
   "ehdaa": 38.4
 },
 {
   "_id": 61,
   "school_code": 841038,
   "nom": "l'Horizon",
   "ville": "Repentigny",
   "secteur": "public",
   "rang_2021_2022": 347,
   "rang_moyenne_5_ans": "340",
   "tendance": "—",
   "cote_2021_2022": 4.9,
   "cote_moyenne_5_ans": "4.7",
   "ehdaa": 42
 },
 {
   "_id": 29,
   "school_code": 841050,
   "nom": "de l'Amitié",
   "ville": "L'Assomption",
   "secteur": "public",
   "rang_2021_2022": 446,
   "rang_moyenne_5_ans": "370",
   "tendance": "998855",
   "cote_2021_2022": 3,
   "cote_moyenne_5_ans": "4.1",
   "ehdaa": 46.6
 },
 {
   "_id": 154,
   "school_code": 841105,
   "nom": "le Prélude",
   "ville": "Mascouche",
   "secteur": "public",
   "rang_2021_2022": 316,
   "rang_moyenne_5_ans": "228",
   "tendance": "—",
   "cote_2021_2022": 5.2,
   "cote_moyenne_5_ans": "5.7",
   "ehdaa": 34.7
 },
 {
   "_id": 40,
   "school_code": 841131,
   "nom": "de l'Odyssée",
   "ville": "Terrebonne",
   "secteur": "public",
   "rang_2021_2022": 364,
   "rang_moyenne_5_ans": "277",
   "tendance": "998855",
   "cote_2021_2022": 4.7,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 44.4
 },
 {
   "_id": 160,
   "school_code": 841134,
   "nom": "des Trois-Saisons",
   "ville": "Terrebonne",
   "secteur": "public",
   "rang_2021_2022": 217,
   "rang_moyenne_5_ans": "241",
   "tendance": "—",
   "cote_2021_2022": 6.1,
   "cote_moyenne_5_ans": "5.6",
   "ehdaa": 34.4
 },
 {
   "_id": 37,
   "school_code": 842009,
   "nom": "du Havre-Jeunesse",
   "ville": "Sainte-Julienne",
   "secteur": "public",
   "rang_2021_2022": 450,
   "rang_moyenne_5_ans": "403",
   "tendance": "—",
   "cote_2021_2022": 2.8,
   "cote_moyenne_5_ans": "2.9",
   "ehdaa": 44.7
 },
 {
   "_id": 120,
   "school_code": 842098,
   "nom": "de L'Achigan",
   "ville": "Saint-Roch-de-l'Achigan",
   "secteur": "public",
   "rang_2021_2022": 452,
   "rang_moyenne_5_ans": "398",
   "tendance": "—",
   "cote_2021_2022": 2.7,
   "cote_moyenne_5_ans": "3.3",
   "ehdaa": 36.7
 },
 {
   "_id": 196,
   "school_code": 842103,
   "nom": "Thérèse-Martin",
   "ville": "Joliette",
   "secteur": "public",
   "rang_2021_2022": 337,
   "rang_moyenne_5_ans": "253",
   "tendance": "—",
   "cote_2021_2022": 5,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 32.3
 },
 {
   "_id": 206,
   "school_code": 842104,
   "nom": "Pierre-de-Lestage",
   "ville": "Berthierville",
   "secteur": "public",
   "rang_2021_2022": 465,
   "rang_moyenne_5_ans": "391",
   "tendance": "—",
   "cote_2021_2022": 1.2,
   "cote_moyenne_5_ans": "3.6",
   "ehdaa": 31.8
 },
 {
   "_id": 172,
   "school_code": 842105,
   "nom": "Barthélemy-Joliette",
   "ville": "Joliette",
   "secteur": "public",
   "rang_2021_2022": 383,
   "rang_moyenne_5_ans": "394",
   "tendance": "—",
   "cote_2021_2022": 4.4,
   "cote_moyenne_5_ans": "3.5",
   "ehdaa": 34
 },
 {
   "_id": 35,
   "school_code": 842108,
   "nom": "Bermon",
   "ville": "Saint-Gabriel",
   "secteur": "public",
   "rang_2021_2022": 417,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 3.7,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 45.4
 },
 {
   "_id": 72,
   "school_code": 842109,
   "nom": "des Chutes",
   "ville": "Rawdon",
   "secteur": "public",
   "rang_2021_2022": 457,
   "rang_moyenne_5_ans": "409",
   "tendance": "—",
   "cote_2021_2022": 2.2,
   "cote_moyenne_5_ans": "2.2",
   "ehdaa": 40.8
 },
 {
   "_id": 52,
   "school_code": 842199,
   "nom": "de L'Érablière",
   "ville": "Saint-Félix-de-Valois",
   "secteur": "public",
   "rang_2021_2022": 179,
   "rang_moyenne_5_ans": "288",
   "tendance": "112233",
   "cote_2021_2022": 6.4,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 42.8
 },
 {
   "_id": 168,
   "school_code": 851105,
   "nom": "Polyvalente Sainte-Thérèse",
   "ville": "Sainte-Thérèse",
   "secteur": "public",
   "rang_2021_2022": 121,
   "rang_moyenne_5_ans": "179",
   "tendance": "—",
   "cote_2021_2022": 7,
   "cote_moyenne_5_ans": "6.1",
   "ehdaa": 34
 },
 {
   "_id": 148,
   "school_code": 851106,
   "nom": "Lucille-Teasdale",
   "ville": "Blainville",
   "secteur": "public",
   "rang_2021_2022": 179,
   "rang_moyenne_5_ans": "208",
   "tendance": "112233",
   "cote_2021_2022": 6.4,
   "cote_moyenne_5_ans": "5.9",
   "ehdaa": 34.9
 },
 {
   "_id": 133,
   "school_code": 851108,
   "nom": "Henri-Dunant",
   "ville": "Blainville",
   "secteur": "public",
   "rang_2021_2022": 203,
   "rang_moyenne_5_ans": "264",
   "tendance": "—",
   "cote_2021_2022": 6.2,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 35.8
 },
 {
   "_id": 111,
   "school_code": 851143,
   "nom": "des Patriotes",
   "ville": "Saint-Eustache",
   "secteur": "public",
   "rang_2021_2022": 286,
   "rang_moyenne_5_ans": "288",
   "tendance": "—",
   "cote_2021_2022": 5.5,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 37.3
 },
 {
   "_id": 181,
   "school_code": 851144,
   "nom": "Deux-Montagnes",
   "ville": "Deux-Montagnes",
   "secteur": "public",
   "rang_2021_2022": 246,
   "rang_moyenne_5_ans": "208",
   "tendance": "—",
   "cote_2021_2022": 5.9,
   "cote_moyenne_5_ans": "5.9",
   "ehdaa": 33.3
 },
 {
   "_id": 101,
   "school_code": 851171,
   "nom": "Jean-Jacques-Rousseau",
   "ville": "Boisbriand",
   "secteur": "public",
   "rang_2021_2022": 352,
   "rang_moyenne_5_ans": "378",
   "tendance": "—",
   "cote_2021_2022": 4.8,
   "cote_moyenne_5_ans": "4.0",
   "ehdaa": 38.4
 },
 {
   "_id": 122,
   "school_code": 852059,
   "nom": "Lavigne",
   "ville": "Lachute",
   "secteur": "public",
   "rang_2021_2022": 352,
   "rang_moyenne_5_ans": "314",
   "tendance": "—",
   "cote_2021_2022": 4.8,
   "cote_moyenne_5_ans": "5.0",
   "ehdaa": 36.6
 },
 {
   "_id": 128,
   "school_code": 853001,
   "nom": "Curé-Mercure",
   "ville": "Mont-Tremblant",
   "secteur": "public",
   "rang_2021_2022": 264,
   "rang_moyenne_5_ans": "264",
   "tendance": "—",
   "cote_2021_2022": 5.7,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 36.1
 },
 {
   "_id": 84,
   "school_code": 853028,
   "nom": "Monts",
   "ville": "Sainte-Agathe-des-Monts",
   "secteur": "public",
   "rang_2021_2022": 192,
   "rang_moyenne_5_ans": "138",
   "tendance": "—",
   "cote_2021_2022": 6.3,
   "cote_moyenne_5_ans": "6.6",
   "ehdaa": 39.4
 },
 {
   "_id": 70,
   "school_code": 854017,
   "nom": "Saint-Joseph",
   "ville": "Mont-Laurier",
   "secteur": "public",
   "rang_2021_2022": 234,
   "rang_moyenne_5_ans": "156",
   "tendance": "—",
   "cote_2021_2022": 6,
   "cote_moyenne_5_ans": "6.3",
   "ehdaa": 40.8
 },
 {
   "_id": 134,
   "school_code": 861005,
   "nom": "Fernand-Lefebvre",
   "ville": "Sorel-Tracy",
   "secteur": "public",
   "rang_2021_2022": 316,
   "rang_moyenne_5_ans": "391",
   "tendance": "112233",
   "cote_2021_2022": 5.2,
   "cote_moyenne_5_ans": "3.6",
   "ehdaa": 35.7
 },
 {
   "_id": 166,
   "school_code": 862002,
   "nom": "Casavant",
   "ville": "Saint-Hyacinthe",
   "secteur": "public",
   "rang_2021_2022": 297,
   "rang_moyenne_5_ans": "354",
   "tendance": "112233",
   "cote_2021_2022": 5.4,
   "cote_moyenne_5_ans": "4.5",
   "ehdaa": 34.1
 },
 {
   "_id": 113,
   "school_code": 862005,
   "nom": "Hyacinthe-Delorme",
   "ville": "Saint-Hyacinthe",
   "secteur": "public",
   "rang_2021_2022": 352,
   "rang_moyenne_5_ans": "228",
   "tendance": "—",
   "cote_2021_2022": 4.8,
   "cote_moyenne_5_ans": "5.7",
   "ehdaa": 37.3
 },
 {
   "_id": 51,
   "school_code": 862052,
   "nom": "Robert-Ouimet",
   "ville": "Acton Vale",
   "secteur": "public",
   "rang_2021_2022": 383,
   "rang_moyenne_5_ans": "288",
   "tendance": "—",
   "cote_2021_2022": 4.4,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 43
 },
 {
   "_id": 139,
   "school_code": 863005,
   "nom": "Paul-Germain-Ostiguy",
   "ville": "Saint-Césaire",
   "secteur": "public",
   "rang_2021_2022": 435,
   "rang_moyenne_5_ans": "382",
   "tendance": "—",
   "cote_2021_2022": 3.4,
   "cote_moyenne_5_ans": "3.9",
   "ehdaa": 35.5
 },
 {
   "_id": 174,
   "school_code": 863069,
   "nom": "Monseigneur-Euclide-Théberge",
   "ville": "Marieville",
   "secteur": "public",
   "rang_2021_2022": 164,
   "rang_moyenne_5_ans": "228",
   "tendance": "—",
   "cote_2021_2022": 6.5,
   "cote_moyenne_5_ans": "5.7",
   "ehdaa": 33.8
 },
 {
   "_id": 23,
   "school_code": 864271,
   "nom": "l'Agora",
   "ville": "Longueuil",
   "secteur": "public",
   "rang_2021_2022": 286,
   "rang_moyenne_5_ans": "302",
   "tendance": "—",
   "cote_2021_2022": 5.5,
   "cote_moyenne_5_ans": "5.1",
   "ehdaa": 49
 },
 {
   "_id": 201,
   "school_code": 864276,
   "nom": "Antoine-Brossard",
   "ville": "Brossard",
   "secteur": "public",
   "rang_2021_2022": 399,
   "rang_moyenne_5_ans": "358",
   "tendance": "—",
   "cote_2021_2022": 4.1,
   "cote_moyenne_5_ans": "4.4",
   "ehdaa": 32
 },
 {
   "_id": 44,
   "school_code": 864278,
   "nom": "Gérard-Filion",
   "ville": "Longueuil",
   "secteur": "public",
   "rang_2021_2022": 464,
   "rang_moyenne_5_ans": "406",
   "tendance": "—",
   "cote_2021_2022": 1.4,
   "cote_moyenne_5_ans": "2.6",
   "ehdaa": 44.2
 },
 {
   "_id": 216,
   "school_code": 864280,
   "nom": "Jacques-Rousseau",
   "ville": "Longueuil",
   "secteur": "public",
   "rang_2021_2022": 352,
   "rang_moyenne_5_ans": "288",
   "tendance": "—",
   "cote_2021_2022": 4.8,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 30.9
 },
 {
   "_id": 90,
   "school_code": 864284,
   "nom": "Monseigneur-A.-M.-Parent",
   "ville": "Longueuil",
   "secteur": "public",
   "rang_2021_2022": 442,
   "rang_moyenne_5_ans": "394",
   "tendance": "—",
   "cote_2021_2022": 3.2,
   "cote_moyenne_5_ans": "3.5",
   "ehdaa": 39.1
 },
 {
   "_id": 167,
   "school_code": 864287,
   "nom": "Saint-Jean-Baptiste",
   "ville": "Longueuil",
   "secteur": "public",
   "rang_2021_2022": 439,
   "rang_moyenne_5_ans": "370",
   "tendance": "—",
   "cote_2021_2022": 3.3,
   "cote_moyenne_5_ans": "4.1",
   "ehdaa": 34.1
 },
 {
   "_id": 19,
   "school_code": 865106,
   "nom": "Polybel",
   "ville": "Beloeil",
   "secteur": "public",
   "rang_2021_2022": 297,
   "rang_moyenne_5_ans": "314",
   "tendance": "—",
   "cote_2021_2022": 5.4,
   "cote_moyenne_5_ans": "5.0",
   "ehdaa": 50.5
 },
 {
   "_id": 224,
   "school_code": 865117,
   "nom": "De Mortagne",
   "ville": "Boucherville",
   "secteur": "public",
   "rang_2021_2022": 121,
   "rang_moyenne_5_ans": "131",
   "tendance": "112233",
   "cote_2021_2022": 7,
   "cote_moyenne_5_ans": "6.7",
   "ehdaa": 30.4
 },
 {
   "_id": 24,
   "school_code": 865225,
   "nom": "du Mont-Bruno",
   "ville": "Saint-Bruno-de-Montarville",
   "secteur": "public",
   "rang_2021_2022": 316,
   "rang_moyenne_5_ans": "346",
   "tendance": "—",
   "cote_2021_2022": 5.2,
   "cote_moyenne_5_ans": "4.6",
   "ehdaa": 49
 },
 {
   "_id": 164,
   "school_code": 865276,
   "nom": "du Grand-Coteau",
   "ville": "Sainte-Julie",
   "secteur": "public",
   "rang_2021_2022": 192,
   "rang_moyenne_5_ans": "302",
   "tendance": "112233",
   "cote_2021_2022": 6.3,
   "cote_moyenne_5_ans": "5.1",
   "ehdaa": 34.2
 },
 {
   "_id": 151,
   "school_code": 865285,
   "nom": "le Carrefour",
   "ville": "Varennes",
   "secteur": "public",
   "rang_2021_2022": 327,
   "rang_moyenne_5_ans": "346",
   "tendance": "—",
   "cote_2021_2022": 5.1,
   "cote_moyenne_5_ans": "4.6",
   "ehdaa": 34.8
 },
 {
   "_id": 143,
   "school_code": 866051,
   "nom": "de la Haute-Ville",
   "ville": "Granby",
   "secteur": "public",
   "rang_2021_2022": 364,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 4.7,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 35.3
 },
 {
   "_id": 88,
   "school_code": 866052,
   "nom": "Joseph-Hermas-Leclerc",
   "ville": "Granby",
   "secteur": "public",
   "rang_2021_2022": 444,
   "rang_moyenne_5_ans": "364",
   "tendance": "—",
   "cote_2021_2022": 3.1,
   "cote_moyenne_5_ans": "4.3",
   "ehdaa": 39.3
 },
 {
   "_id": 69,
   "school_code": 866053,
   "nom": "Wilfrid-Léger",
   "ville": "Waterloo",
   "secteur": "public",
   "rang_2021_2022": 383,
   "rang_moyenne_5_ans": "326",
   "tendance": "—",
   "cote_2021_2022": 4.4,
   "cote_moyenne_5_ans": "4.9",
   "ehdaa": 40.9
 },
 {
   "_id": 225,
   "school_code": 866055,
   "nom": "Jean-Jacques-Bertrand",
   "ville": "Farnham",
   "secteur": "public",
   "rang_2021_2022": 264,
   "rang_moyenne_5_ans": "156",
   "tendance": "—",
   "cote_2021_2022": 5.7,
   "cote_moyenne_5_ans": "6.3",
   "ehdaa": 30.4
 },
 {
   "_id": 178,
   "school_code": 867076,
   "nom": "Louis-Cyr",
   "ville": "Napierville",
   "secteur": "public",
   "rang_2021_2022": 150,
   "rang_moyenne_5_ans": "150",
   "tendance": "112233",
   "cote_2021_2022": 6.7,
   "cote_moyenne_5_ans": "6.4",
   "ehdaa": 33.4
 },
 {
   "_id": 87,
   "school_code": 868035,
   "nom": "des Patriotes",
   "ville": "Beauharnois",
   "secteur": "public",
   "rang_2021_2022": 327,
   "rang_moyenne_5_ans": "302",
   "tendance": "—",
   "cote_2021_2022": 5.1,
   "cote_moyenne_5_ans": "5.1",
   "ehdaa": 39.3
 },
 {
   "_id": 41,
   "school_code": 868039,
   "nom": "de la Baie-Saint-François",
   "ville": "Salaberry-de-Valleyfield",
   "secteur": "public",
   "rang_2021_2022": 444,
   "rang_moyenne_5_ans": "364",
   "tendance": "—",
   "cote_2021_2022": 3.1,
   "cote_moyenne_5_ans": "4.3",
   "ehdaa": 44.4
 },
 {
   "_id": 53,
   "school_code": 868040,
   "nom": "Arthur Pigeon",
   "ville": "Huntingdon",
   "secteur": "public",
   "rang_2021_2022": 435,
   "rang_moyenne_5_ans": "370",
   "tendance": "998855",
   "cote_2021_2022": 3.4,
   "cote_moyenne_5_ans": "4.1",
   "ehdaa": 42.7
 },
 {
   "_id": 165,
   "school_code": 871012,
   "nom": "Jean-Nicolet",
   "ville": "Nicolet",
   "secteur": "public",
   "rang_2021_2022": 264,
   "rang_moyenne_5_ans": "288",
   "tendance": "—",
   "cote_2021_2022": 5.7,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 34.1
 },
 {
   "_id": 78,
   "school_code": 871013,
   "nom": "La Découverte",
   "ville": "Saint-Léonard-d'Aston",
   "secteur": "public",
   "rang_2021_2022": 307,
   "rang_moyenne_5_ans": "241",
   "tendance": "—",
   "cote_2021_2022": 5.3,
   "cote_moyenne_5_ans": "5.6",
   "ehdaa": 39.9
 },
 {
   "_id": 138,
   "school_code": 871019,
   "nom": "les Seigneuries",
   "ville": "Saint-Pierre-les-Becquets",
   "secteur": "public",
   "rang_2021_2022": 428,
   "rang_moyenne_5_ans": "364",
   "tendance": "998855",
   "cote_2021_2022": 3.5,
   "cote_moyenne_5_ans": "4.3",
   "ehdaa": 35.5
 },
 {
   "_id": 93,
   "school_code": 872069,
   "nom": "La Samare",
   "ville": "Plessisville",
   "secteur": "public",
   "rang_2021_2022": 118,
   "rang_moyenne_5_ans": "96",
   "tendance": "—",
   "cote_2021_2022": 7.1,
   "cote_moyenne_5_ans": "7.3",
   "ehdaa": 38.7
 },
 {
   "_id": 227,
   "school_code": 872070,
   "nom": "Sainte-Marie",
   "ville": "Princeville",
   "secteur": "public",
   "rang_2021_2022": 264,
   "rang_moyenne_5_ans": "179",
   "tendance": "—",
   "cote_2021_2022": 5.7,
   "cote_moyenne_5_ans": "6.1",
   "ehdaa": 30.3
 },
 {
   "_id": 173,
   "school_code": 872071,
   "nom": "Sainte-Anne",
   "ville": "Daveluyville",
   "secteur": "public",
   "rang_2021_2022": 58,
   "rang_moyenne_5_ans": "88",
   "tendance": "—",
   "cote_2021_2022": 8.1,
   "cote_moyenne_5_ans": "7.4",
   "ehdaa": 33.9
 },
 {
   "_id": 55,
   "school_code": 873050,
   "nom": "Jean-Raimbault",
   "ville": "Drummondville",
   "secteur": "public",
   "rang_2021_2022": 217,
   "rang_moyenne_5_ans": "241",
   "tendance": "—",
   "cote_2021_2022": 6.1,
   "cote_moyenne_5_ans": "5.6",
   "ehdaa": 42.5
 },
 {
   "_id": 109,
   "school_code": 873053,
   "nom": "Jeanne-Mance",
   "ville": "Drummondville",
   "secteur": "public",
   "rang_2021_2022": 316,
   "rang_moyenne_5_ans": "264",
   "tendance": "—",
   "cote_2021_2022": 5.2,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 37.4
 },
 {
   "_id": 170,
   "school_code": 873055,
   "nom": "Marie-Rivier",
   "ville": "Drummondville",
   "secteur": "public",
   "rang_2021_2022": 164,
   "rang_moyenne_5_ans": "179",
   "tendance": "—",
   "cote_2021_2022": 6.5,
   "cote_moyenne_5_ans": "6.1",
   "ehdaa": 34
 },
 {
   "_id": 39,
   "school_code": 873057,
   "nom": "La Poudrière",
   "ville": "Drummondville",
   "secteur": "public",
   "rang_2021_2022": 375,
   "rang_moyenne_5_ans": "354",
   "tendance": "—",
   "cote_2021_2022": 4.6,
   "cote_moyenne_5_ans": "4.5",
   "ehdaa": 44.5
 },
 {
   "_id": 119,
   "school_code": 882002,
   "nom": "New Carlisle",
   "ville": "New Carlisle",
   "secteur": "public",
   "rang_2021_2022": 404,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 4,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 36.7
 },
 {
   "_id": 43,
   "school_code": 882112,
   "nom": "Queen Elizabeth",
   "ville": "Sept-Îles",
   "secteur": "public",
   "rang_2021_2022": 411,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 3.9,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 44.2
 },
 {
   "_id": 20,
   "school_code": 883022,
   "nom": "Alexander Galt",
   "ville": "Sherbrooke",
   "secteur": "public",
   "rang_2021_2022": 297,
   "rang_moyenne_5_ans": "314",
   "tendance": "—",
   "cote_2021_2022": 5.4,
   "cote_moyenne_5_ans": "5.0",
   "ehdaa": 49.7
 },
 {
   "_id": 13,
   "school_code": 883023,
   "nom": "Massey-Vanier",
   "ville": "Cowansville",
   "secteur": "public",
   "rang_2021_2022": 389,
   "rang_moyenne_5_ans": "288",
   "tendance": "998855",
   "cote_2021_2022": 4.3,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 53.3
 },
 {
   "_id": 86,
   "school_code": 883024,
   "nom": "Richmond",
   "ville": "Richmond",
   "secteur": "public",
   "rang_2021_2022": 352,
   "rang_moyenne_5_ans": "288",
   "tendance": "—",
   "cote_2021_2022": 4.8,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 39.4
 },
 {
   "_id": 127,
   "school_code": 884001,
   "nom": "St. John's",
   "ville": "Saint-Jean-sur-Richelieu",
   "secteur": "public",
   "rang_2021_2022": 383,
   "rang_moyenne_5_ans": "264",
   "tendance": "—",
   "cote_2021_2022": 4.4,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 36.2
 },
 {
   "_id": 124,
   "school_code": 884016,
   "nom": "Heritage Regional",
   "ville": "Saint-Hubert",
   "secteur": "public",
   "rang_2021_2022": 255,
   "rang_moyenne_5_ans": "208",
   "tendance": "—",
   "cote_2021_2022": 5.8,
   "cote_moyenne_5_ans": "5.9",
   "ehdaa": 36.4
 },
 {
   "_id": 116,
   "school_code": 884032,
   "nom": "Chambly",
   "ville": "Saint-Lambert",
   "secteur": "public",
   "rang_2021_2022": 307,
   "rang_moyenne_5_ans": "368",
   "tendance": "—",
   "cote_2021_2022": 5.3,
   "cote_moyenne_5_ans": "4.2",
   "ehdaa": 37
 },
 {
   "_id": 171,
   "school_code": 884035,
   "nom": "Centennial",
   "ville": "Greenfield Park",
   "secteur": "public",
   "rang_2021_2022": 203,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2021_2022": 6.2,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 34
 },
 {
   "_id": 189,
   "school_code": 885181,
   "nom": "Joliette",
   "ville": "Joliette",
   "secteur": "public",
   "rang_2021_2022": 264,
   "rang_moyenne_5_ans": "228",
   "tendance": "—",
   "cote_2021_2022": 5.7,
   "cote_moyenne_5_ans": "5.7",
   "ehdaa": 32.8
 },
 {
   "_id": 184,
   "school_code": 885183,
   "nom": "Lake of Two Mountains",
   "ville": "Deux-Montagnes",
   "secteur": "public",
   "rang_2021_2022": 297,
   "rang_moyenne_5_ans": "277",
   "tendance": "112233",
   "cote_2021_2022": 5.4,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 33.1
 },
 {
   "_id": 83,
   "school_code": 885189,
   "nom": "Ste-Agathe",
   "ville": "Sainte-Agathe-des-Monts",
   "secteur": "public",
   "rang_2021_2022": 286,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 5.5,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 39.5
 },
 {
   "_id": 105,
   "school_code": 886001,
   "nom": "Philemon Wright",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2021_2022": 192,
   "rang_moyenne_5_ans": "138",
   "tendance": "—",
   "cote_2021_2022": 6.3,
   "cote_moyenne_5_ans": "6.6",
   "ehdaa": 38
 },
 {
   "_id": 12,
   "school_code": 886002,
   "nom": "Pontiac",
   "ville": "Shawville",
   "secteur": "public",
   "rang_2021_2022": 393,
   "rang_moyenne_5_ans": "346",
   "tendance": "998855",
   "cote_2021_2022": 4.2,
   "cote_moyenne_5_ans": "4.6",
   "ehdaa": 54
 },
 {
   "_id": 103,
   "school_code": 886004,
   "nom": "D'Arcy McGee",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2021_2022": 203,
   "rang_moyenne_5_ans": "179",
   "tendance": "—",
   "cote_2021_2022": 6.2,
   "cote_moyenne_5_ans": "6.1",
   "ehdaa": 38.2
 },
 {
   "_id": 59,
   "school_code": 886005,
   "nom": "Dr. Wilbert Keon",
   "ville": "L'Isle-aux-Allumettes",
   "secteur": "public",
   "rang_2021_2022": 255,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 5.8,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 42.4
 },
 {
   "_id": 11,
   "school_code": 886012,
   "nom": "Saint-Michael",
   "ville": "Low",
   "secteur": "public",
   "rang_2021_2022": 164,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 6.5,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 56.4
 },
 {
   "_id": 230,
   "school_code": 887047,
   "nom": "F.A.C.E.",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 217,
   "rang_moyenne_5_ans": "150",
   "tendance": "—",
   "cote_2021_2022": 6.1,
   "cote_moyenne_5_ans": "6.4",
   "ehdaa": 30.2
 },
 {
   "_id": 4,
   "school_code": 887101,
   "nom": "James Lyng",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 466,
   "rang_moyenne_5_ans": "412",
   "tendance": "—",
   "cote_2021_2022": 0.9,
   "cote_moyenne_5_ans": "0.9",
   "ehdaa": 83.8
 },
 {
   "_id": 7,
   "school_code": 887102,
   "nom": "John F. Kennedy",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 404,
   "rang_moyenne_5_ans": "387",
   "tendance": "—",
   "cote_2021_2022": 4,
   "cote_moyenne_5_ans": "3.8",
   "ehdaa": 64.7
 },
 {
   "_id": 197,
   "school_code": 887104,
   "nom": "LaurenHill",
   "ville": "Saint-Laurent",
   "secteur": "public",
   "rang_2021_2022": 234,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2021_2022": 6,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 32.2
 },
 {
   "_id": 219,
   "school_code": 887106,
   "nom": "Lester B. Pearson",
   "ville": "Montréal-Nord",
   "secteur": "public",
   "rang_2021_2022": 297,
   "rang_moyenne_5_ans": "264",
   "tendance": "—",
   "cote_2021_2022": 5.4,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 30.7
 },
 {
   "_id": 129,
   "school_code": 887108,
   "nom": "Marymount",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 307,
   "rang_moyenne_5_ans": "336",
   "tendance": "—",
   "cote_2021_2022": 5.3,
   "cote_moyenne_5_ans": "4.8",
   "ehdaa": 36.1
 },
 {
   "_id": 210,
   "school_code": 887110,
   "nom": "Rosemount",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 364,
   "rang_moyenne_5_ans": "277",
   "tendance": "—",
   "cote_2021_2022": 4.7,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 31.5
 },
 {
   "_id": 213,
   "school_code": 887116,
   "nom": "Westmount",
   "ville": "Westmount",
   "secteur": "public",
   "rang_2021_2022": 234,
   "rang_moyenne_5_ans": "179",
   "tendance": "—",
   "cote_2021_2022": 6,
   "cote_moyenne_5_ans": "6.1",
   "ehdaa": 31.2
 },
 {
   "_id": 1,
   "school_code": 887203,
   "nom": "Options II",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2021_2022": 442,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2021_2022": 3.2,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 92
 },
 {
   "_id": 141,
   "school_code": 888051,
   "nom": "Beaconsfield",
   "ville": "Beaconsfield",
   "secteur": "public",
   "rang_2021_2022": 255,
   "rang_moyenne_5_ans": "173",
   "tendance": "—",
   "cote_2021_2022": 5.8,
   "cote_moyenne_5_ans": "6.2",
   "ehdaa": 35.3
 },
 {
   "_id": 107,
   "school_code": 888055,
   "nom": "Westwood",
   "ville": "Hudson",
   "secteur": "public",
   "rang_2021_2022": 203,
   "rang_moyenne_5_ans": "173",
   "tendance": "—",
   "cote_2021_2022": 6.2,
   "cote_moyenne_5_ans": "6.2",
   "ehdaa": 37.7
 },
 {
   "_id": 21,
   "school_code": 888058,
   "nom": "Lakeside",
   "ville": "Lachine",
   "secteur": "public",
   "rang_2021_2022": 316,
   "rang_moyenne_5_ans": "326",
   "tendance": "—",
   "cote_2021_2022": 5.2,
   "cote_moyenne_5_ans": "4.9",
   "ehdaa": 49.6
 },
 {
   "_id": 185,
   "school_code": 888059,
   "nom": "LaSalle",
   "ville": "Lasalle",
   "secteur": "public",
   "rang_2021_2022": 383,
   "rang_moyenne_5_ans": "288",
   "tendance": "—",
   "cote_2021_2022": 4.4,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 33.1
 },
 {
   "_id": 100,
   "school_code": 888061,
   "nom": "MacDonald",
   "ville": "Sainte-Anne-de-Bellevue",
   "secteur": "public",
   "rang_2021_2022": 307,
   "rang_moyenne_5_ans": "241",
   "tendance": "998855",
   "cote_2021_2022": 5.3,
   "cote_moyenne_5_ans": "5.6",
   "ehdaa": 38.4
 },
 {
   "_id": 38,
   "school_code": 888062,
   "nom": "Pierrefonds",
   "ville": "Pierrefonds",
   "secteur": "public",
   "rang_2021_2022": 217,
   "rang_moyenne_5_ans": "138",
   "tendance": "—",
   "cote_2021_2022": 6.1,
   "cote_moyenne_5_ans": "6.6",
   "ehdaa": 44.6
 },
 {
   "_id": 14,
   "school_code": 888069,
   "nom": "Beurling",
   "ville": "Verdun",
   "secteur": "public",
   "rang_2021_2022": 456,
   "rang_moyenne_5_ans": "403",
   "tendance": "—",
   "cote_2021_2022": 2.3,
   "cote_moyenne_5_ans": "2.9",
   "ehdaa": 51.9
 },
 {
   "_id": 92,
   "school_code": 889014,
   "nom": "Châteauguay Valley",
   "ville": "Ormstown",
   "secteur": "public",
   "rang_2021_2022": 316,
   "rang_moyenne_5_ans": "314",
   "tendance": "—",
   "cote_2021_2022": 5.2,
   "cote_moyenne_5_ans": "5.0",
   "ehdaa": 38.8
 },
 {
   "_id": 79,
   "school_code": 889016,
   "nom": "Howard S. Billings",
   "ville": "Châteauguay",
   "secteur": "public",
   "rang_2021_2022": 375,
   "rang_moyenne_5_ans": "358",
   "tendance": "—",
   "cote_2021_2022": 4.6,
   "cote_moyenne_5_ans": "4.4",
   "ehdaa": 39.8
 }
]
